import React from 'react';
import StylingMockLayout from '../shared/StylingMockLayout';
import '../../../styles/typography.css';
import './StylingMockTypography.css';

/**
 * Styling Mock Typography Page
 * Showcases typography styles
 */
const StylingMockTypography = () => {

  return (
    <StylingMockLayout>
      <div className="styling-mock-typography">
        <div className="styling-mock-section">
          <h2 className="styling-mock-section-title">Typography</h2>
          <p className="styling-mock-section-description">
            See typography styles for headings, paragraphs, links, lists, blockquotes, code blocks, and text formatting.
          </p>
        </div>

        {/* Headings */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Headings</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <h1>Heading 1 (h1)</h1>
              <h2>Heading 2 (h2)</h2>
              <h3>Heading 3 (h3)</h3>
              <h4>Heading 4 (h4)</h4>
              <h5>Heading 5 (h5)</h5>
              <h6>Heading 6 (h6)</h6>
            </div>
            <div className="styling-mock-code-block">
{`<h1>Heading 1 (h1)</h1>
<h2>Heading 2 (h2)</h2>
<h3>Heading 3 (h3)</h3>
<h4>Heading 4 (h4)</h4>
<h5>Heading 5 (h5)</h5>
<h6>Heading 6 (h6)</h6>`}
            </div>
          </div>
        </div>

        {/* Paragraphs */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Paragraphs</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <p>This is a regular paragraph with normal text. It demonstrates the default paragraph styling.</p>
              <p><strong>This is bold text.</strong></p>
              <p><em>This is italic text.</em></p>
              <p><small>This is small text.</small></p>
            </div>
            <div className="styling-mock-code-block">
{`<p>This is a regular paragraph with normal text.</p>
<p><strong>This is bold text.</strong></p>
<p><em>This is italic text.</em></p>
<p><small>This is small text.</small></p>`}
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Links</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <p>
                <a href="#example">This is a link</a> with default styling.
              </p>
              <p>
                <a href="#example" className="hover-link">This is a link</a> with hover effects.
              </p>
            </div>
            <div className="styling-mock-code-block">
{`<a href="#example">This is a link</a>
<a href="#example" className="hover-link">This is a link</a>`}
            </div>
          </div>
        </div>

        {/* Lists */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Lists</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <ul>
                <li>Unordered list item 1</li>
                <li>Unordered list item 2</li>
                <li>Unordered list item 3</li>
              </ul>
              <ol>
                <li>Ordered list item 1</li>
                <li>Ordered list item 2</li>
                <li>Ordered list item 3</li>
              </ol>
            </div>
            <div className="styling-mock-code-block">
{`<ul>
  <li>Unordered list item 1</li>
  <li>Unordered list item 2</li>
  <li>Unordered list item 3</li>
</ul>
<ol>
  <li>Ordered list item 1</li>
  <li>Ordered list item 2</li>
  <li>Ordered list item 3</li>
</ol>`}
            </div>
          </div>
        </div>

        {/* Blockquote */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Blockquote</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <blockquote>
                This is a blockquote example. It demonstrates how quoted text is displayed.
              </blockquote>
            </div>
            <div className="styling-mock-code-block">
{`<blockquote>
  This is a blockquote example. It demonstrates how quoted text is displayed.
</blockquote>`}
            </div>
          </div>
        </div>

        {/* Code */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Code</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <p>Inline code: <code>const example = 'code';</code></p>
              <pre><code>{`const example = 'code block';
console.log(example);`}</code></pre>
            </div>
            <div className="styling-mock-code-block">
{`<p>Inline code: <code>const example = 'code';</code></p>
<pre><code>const example = 'code block';
console.log(example);</code></pre>`}
            </div>
          </div>
        </div>

        {/* Horizontal Rule */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Horizontal Rule</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <p>Content above the line</p>
              <hr />
              <p>Content below the line</p>
            </div>
            <div className="styling-mock-code-block">
{`<p>Content above the line</p>
<hr />
<p>Content below the line</p>`}
            </div>
          </div>
        </div>
      </div>
    </StylingMockLayout>
  );
};

export default StylingMockTypography;

